// src/features/executive/performance/PerformanceTab.tsx
import { useTranslation } from 'react-i18next'
import SectionHeader from 'features/executive/components/SectionHeader/SectionHeader'
import RevenueSummaryTile from './widgets/RevenueSummaryTile'
import AvgBillTile from './widgets/AvgBillTile'
import AvgRevenueTile from './widgets/AvgRevenueTile'
import PatientSummaryCard from './widgets/PatientSummaryCard'
import RevenueTrendCard from './widgets/RevenueTrendCard'
import PerBranchRevenueCard from './widgets/PerBranchRevenueCard'
import KeyProceduresCard from './widgets/KeyProceduresCard'
import AppointmentsCard from './widgets/AppointmentsCard'
import { DetailRow, HeroRow, Section, TabRoot } from './usedStyle'

export default function PerformanceTab() {
  const { t } = useTranslation()
  return (
    <TabRoot>
      {/* Section 1: KPI hero — top-line metrics at a glance */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.PERFORMANCE.SECTION.KPI')}
          caption={t('EXECUTIVE.PERFORMANCE.SECTION.KPI_CAPTION')}
        />
        <HeroRow>
          <RevenueSummaryTile />
          <AvgBillTile />
          <AvgRevenueTile />
          <PatientSummaryCard />
        </HeroRow>
      </Section>

      {/* Section 2: Trends & branches — where revenue comes from over time */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.PERFORMANCE.SECTION.TRENDS')}
          caption={t('EXECUTIVE.PERFORMANCE.SECTION.TRENDS_CAPTION')}
        />
        <RevenueTrendCard />
        <PerBranchRevenueCard />
      </Section>

      {/* Section 3: Top drivers — procedures & appointments mix */}
      <Section>
        <SectionHeader
          label={t('EXECUTIVE.PERFORMANCE.SECTION.DRIVERS')}
          caption={t('EXECUTIVE.PERFORMANCE.SECTION.DRIVERS_CAPTION')}
        />
        <DetailRow>
          <KeyProceduresCard />
          <AppointmentsCard />
        </DetailRow>
      </Section>
    </TabRoot>
  )
}
